import NavBar from "../NavBar";

function About() {
    return (
        <>
            <NavBar/>
        <div className="body">
            <h2>About</h2>
            <p>Created by Jared Rudnicki and Jessica Chin</p>
        </div>
        </>
    )
}
export default About